import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthScaffold } from "./Login";

export function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null); setInfo(null);
    const { error } = await resetPassword(email);
    setBusy(false);
    if (error) setError(error);
    else setInfo("If an account exists for that email, you'll receive a reset link shortly.");
  }

  return (
    <AuthScaffold>
      <h1 className="mb-1 text-2xl font-bold tracking-tight">Reset your password</h1>
      <p className="mb-6 text-sm text-gray2">Enter your email — we'll send you a link to set a new password.</p>
      {error && <div className="mb-4 rounded-lg bg-bad-bg px-3.5 py-2.5 text-sm text-bad">{error}</div>}
      {info && <div className="mb-4 rounded-lg bg-ok-bg px-3.5 py-2.5 text-sm text-ok">{info}</div>}
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="label">Email</label>
          <input className="input" type="email" required value={email} onChange={e => setEmail(e.target.value)} autoFocus />
        </div>
        <button className="btn w-full btn-lg" disabled={busy}>{busy ? "Sending…" : "Send reset link"}</button>
      </form>
      <div className="mt-6 text-center text-sm">
        <Link to="/login" className="text-teal-dark hover:underline">Back to sign in</Link>
      </div>
    </AuthScaffold>
  );
}
